'use client';
import { setCookie, getCookie } from 'cookies-next';

import { diffDate } from './tools/diffDate';
import { featuresCheck } from './tools/featuresCheck';

export const hotelListAndClick = (
  hotels,
  startDate,
  endDate,
  adultCount,
  childCount,
  sort,
  filters,
  query,
  isClick
) => {
  const isChatGpt = query?.kaynak ? true : false;
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');

  if (!isClick && window.location.href === data?.hotel_url) return;

  const formattedStartDate = startDate ? startDate : '';
  const formattedEndDate = endDate ? endDate : '';
  const selectedFilters: string[] = [];
  if (filters?.onlyAvailableProperties) {
    selectedFilters.push('Sadece Müsait Tesisler');
  }
  if (filters?.freeCancellation) {
    selectedFilters.push('Ücretsiz İptal');
  }
  if (filters?.hotelName) {
    selectedFilters.push(`Otel adı:${filters.hotelName}`);
  }
  if (filters?.minAccommodationPrice) {
    selectedFilters.push(`Minimum Fiyat:${filters.minAccommodationPrice}`);
  }
  if (filters?.maxAccommodationPrice) {
    selectedFilters.push(`Maximum Fiyat:${filters.maxAccommodationPrice}`);
  }
  if (filters?.selectedTripAdvisorItem) {
    selectedFilters.push(`Misafir Puanı:${filters.selectedTripAdvisorItem}`);
  }
  filters?.regions?.length > 0 &&
    filters?.regions?.map((item) => {
      if (item?.selected) selectedFilters.push(`Bölge:${item?.value}`);
    });
  filters?.selectedAccommodationTypes?.length > 0 &&
    filters?.selectedAccommodationTypes?.map((item) => {
      if (item?.selected) selectedFilters.push(`Konaklama Tipi:${item?.value}`);
    });
  filters?.selectedPopularitiesItems?.length > 0 &&
    filters?.selectedPopularitiesItems?.map((item) => {
      if (item?.selected)
        selectedFilters.push(`Otel Özellikleri:${item?.value}`);
    });
  filters?.selectedThemeItems?.length > 0 &&
    filters?.selectedThemeItems?.map((item) => {
      if (item?.selected) selectedFilters.push(`Otel Teması:${item?.value}`);
    });
  const items: any[] = [];
  hotels &&
    hotels.map((hotel, index) => {
      const location: string[] =
        (hotel?.location && hotel?.location.split(', ')) || [];
      const locationName = location[1] || location[0];
      const locationWithHotels = locationName.includes('Oteller')
        ? locationName
        : `${locationName} Otelleri`;
      items.push({
        item_id: hotel?.id || 0,
        item_name: hotel?.name || '',
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount:
          (hotel?.pricing?.rate || 0) === 0
            ? 0
            : +(hotel?.pricing?.selling || 0) -
              +(hotel?.pricing?.discounted || 0),
        index: index,
        item_brand: 'Setur',
        item_category: 'Otel',
        item_category2:
          hotel?.domestic || hotel?.cyprus
            ? 'Yurtiçi Otelleri'
            : 'Yurtdışı Otelleri',
        item_category3: isChatGpt
          ? locationWithHotels
          : `${hotel?.city} Otelleri` || data?.hotel_item_list_id,
        item_category4:
          (hotel?.regions && `${hotel?.regions[0]?.name} Otelleri`) ?? '',
        item_category5: hotel.country ?? '',
        cd_item_list_location: isChatGpt
          ? 'Akıllı Asistan'
          : data?.hotel_item_list_location || 'Listing Page',
        item_list_id: isChatGpt
          ? locationWithHotels
          : data?.hotel_item_list_id || `${hotel?.city} Otelleri`,
        item_list_name: `${
          isChatGpt
            ? 'Akıllı Asistan'
            : data?.hotel_item_list_location || 'Listing Page'
        } - ${
          isChatGpt
            ? locationWithHotels
            : data?.hotel_item_list_id || `${hotel?.city} Otelleri`
        }`,
        item_variant: '',
        cd_item_checkin_date: formattedStartDate,
        cd_item_checkout_date: formattedEndDate,
        cd_item_room_type: '',
        cd_item_list_filter: selectedFilters.join(','),
        cd_item_sorting_opt: sort?.label,
        cd_item_hotel_score: hotel?.reviews?.rating || 0,
        cd_item_pet_friendly: featuresCheck('Evcil hayvan', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_near_to_city_center:
          hotel?.distanceFromCenter > 0 && hotel?.distanceFromCenter < 15
            ? 'Yes'
            : 'No',
        cd_item_is_seaside: featuresCheck('Denize Sıfır', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_blue_flag: featuresCheck('Mavi Bayrak', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_aquapark: featuresCheck('Aquapark', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_otel_concept: hotel?.boardType || '',
        cd_item_city: location[1] || '',
        cd_item_region: location[0] || '',
        cd_item_disabled_friendly: featuresCheck('Engelli', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_is_conservative: featuresCheck('Muhafazakar', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_honeymoon: featuresCheck('Balayı', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_discount_rate: parseFloat(hotel?.pricing?.rate || 0) / 100,
        cd_item_days_till_vacation: startDate
          ? diffDate(new Date().toString(), startDate)
          : 0,
        cm_item_total_people_count: +adultCount + +childCount,
        cd_item_child_free: featuresCheck('Çocuk Ücretsiz', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_fly: featuresCheck('Transfer', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_total_reservation_day:
          startDate && endDate ? diffDate(startDate, endDate) : 0,
        cm_item_adult_number: adultCount,
        cm_item_child_number: childCount,
        cd_item_in_stock: hotel?.status === 'OpenSale' ? 'Yes' : 'No',
        cd_item_first_price: hotel?.pricing?.selling || 0,
        price: hotel?.pricing?.discounted || 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    }
    setCookie(
      'DataLayer',
      {
        ...data,
        hotel_item_list_location: items[0]?.cd_item_list_location,
        hotel_item_list_id: items[0]?.item_list_id,
        hotel_url: window.location.href,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  }
};

export const packageListAndClick = (
  hotels,
  startDate,
  endDate,
  adultCount,
  childCount,
  sort,
  filters,
  query,
  isClick
) => {
  const isChatGpt = query?.kaynak ? true : false;
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');

  if (!isClick && window.location.href === data?.package_url) return;

  const formattedStartDate = startDate ? startDate : '';
  const formattedEndDate = endDate ? endDate : '';
  const selectedFilters: string[] = [];
  if (filters?.onlyAvailableProperties) {
    selectedFilters.push('Sadece Müsait Tesisler');
  }
  if (filters?.freeCancellation) {
    selectedFilters.push('Ücretsiz İptal');
  }
  if (filters?.hotelName) {
    selectedFilters.push(`Otel adı:${filters.hotelName}`);
  }
  if (filters?.minAccommodationPrice) {
    selectedFilters.push(`Minimum Fiyat:${filters.minAccommodationPrice}`);
  }
  if (filters?.maxAccommodationPrice) {
    selectedFilters.push(`Maximum Fiyat:${filters.maxAccommodationPrice}`);
  }
  if (filters?.selectedTripAdvisorItem) {
    selectedFilters.push(`Misafir Puanı:${filters.selectedTripAdvisorItem}`);
  }
  filters?.regions?.length > 0 &&
    filters?.regions?.map((item) => {
      if (item?.selected) selectedFilters.push(`Bölge:${item?.value}`);
    });
  filters?.selectedAccommodationTypes?.length > 0 &&
    filters?.selectedAccommodationTypes?.map((item) => {
      if (item?.selected) selectedFilters.push(`Konaklama Tipi:${item?.value}`);
    });
  filters?.selectedPopularitiesItems?.length > 0 &&
    filters?.selectedPopularitiesItems?.map((item) => {
      if (item?.selected)
        selectedFilters.push(`Otel Özellikleri:${item?.value}`);
    });
  filters?.selectedThemeItems?.length > 0 &&
    filters?.selectedThemeItems?.map((item) => {
      if (item?.selected) selectedFilters.push(`Otel Teması:${item?.value}`);
    });
  const items: any[] = [];
  hotels &&
    hotels.map((hotel, index) => {
      const location: string[] =
        (hotel?.location && hotel?.location.split(', ')) || [];
      const locationName = location[1] || location[0];
      const locationWithHotels = locationName.includes('Paketler')
        ? locationName
        : `${locationName} Paketleri`;
      items.push({
        item_id: hotel?.id || 0,
        item_name: hotel?.name || '',
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount:
          (hotel?.pricing?.rate || 0) === 0
            ? 0
            : +(hotel?.pricing?.selling || 0) -
              +(hotel?.pricing?.discounted || 0),
        index: index,
        item_brand: 'Setur',
        item_category: 'Paket',
        item_category2: 'Yurtiçi Otelleri',
        item_category3: isChatGpt
          ? locationWithHotels
          : data?.package_item_list_id || `${hotel?.city} Paketleri`,
        item_category4:
          (hotel?.regions && `${hotel?.regions[0]?.name} Otelleri`) ?? '',
        item_category5: hotel?.country ?? '',
        cd_item_list_location: isChatGpt
          ? 'Akıllı Asistan'
          : data?.package_item_list_location || 'Listing Page',
        item_list_id: isChatGpt
          ? locationWithHotels
          : data?.package_item_list_id || `${hotel?.city} Paketleri`,
        item_list_name: `${
          isChatGpt
            ? 'Akıllı Asistan'
            : data?.package_item_list_location || 'Listing Page'
        } - ${
          isChatGpt
            ? locationWithHotels
            : data?.package_item_list_id || `${hotel?.city} Paketleri`
        }`,
        item_variant: '',
        cd_item_checkin_date: formattedStartDate,
        cd_item_checkout_date: formattedEndDate,
        cd_item_room_type: '',
        cd_item_list_filter: selectedFilters.join(','),
        cd_item_sorting_opt: sort?.label,
        cd_item_hotel_score: hotel?.reviews?.rating || 0,
        cd_item_pet_friendly: featuresCheck('Evcil hayvan', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_near_to_city_center:
          hotel?.distanceFromCenter > 0 && hotel?.distanceFromCenter < 15
            ? 'Yes'
            : 'No',
        cd_item_is_seaside: featuresCheck('Denize Sıfır', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_blue_flag: featuresCheck('Mavi Bayrak', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_aquapark: featuresCheck('Aquapark', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_otel_concept: hotel?.boardType || '',
        cd_item_city: location[1] || '',
        cd_item_region: location[0] || '',
        cd_item_disabled_friendly: featuresCheck('Engelli', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_is_conservative: featuresCheck('Muhafazakar', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_honeymoon: featuresCheck('Balayı', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_discount_rate: parseFloat(hotel?.pricing?.rate || 0) / 100,
        cd_item_days_till_vacation: startDate
          ? diffDate(new Date().toString(), startDate)
          : 0,
        cm_item_total_people_count: +adultCount + +childCount,
        cd_item_child_free: featuresCheck('Çocuk Ücretsiz', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_fly: featuresCheck('Transfer', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_total_reservation_day:
          startDate && endDate ? diffDate(startDate, endDate) : 0,
        cm_item_adult_number: adultCount,
        cm_item_child_number: childCount,
        cd_item_in_stock: hotel?.status === 'OpenSale' ? 'Yes' : 'No',
        cd_item_first_price: hotel?.pricing?.selling || 0,
        price: hotel?.pricing?.discounted || 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    }
    setCookie(
      'DataLayer',
      {
        ...data,
        package_item_list_location: items[0]?.cd_item_list_location,
        package_item_list_id: items[0]?.item_list_id,
        package_url: window.location.href,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  }
};

export const flightListAndClick = (flights, query, sortData, isClick) => {
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');

  if (!isClick && window.location.href === data?.flight_url) return;

  if (isClick) {
    if (query?.IsOneWay === 'false') {
      if (flights?.length < 2) {
        if (data?.flight_select)
          setCookie(
            'DataLayer',
            { ...data, flight_select: false },
            { expires: new Date(Date.now() + 60 * 60 * 1000) }
          );
        return;
      }
    } else {
      if (flights?.length < 1) {
        if (data?.flight_select)
          setCookie(
            'DataLayer',
            { ...data, flight_select: false },
            { expires: new Date(Date.now() + 60 * 60 * 1000) }
          );
        return;
      }
    }
    if (data?.flight_select) return;
  }

  const selectedFilters: string[] = [];
  const filterName = {
    AIRLINES: 'out-airlines',
    CLASSES: 'out-classes',
    DEPARTURE_AIRPORTS: 'out-depAirports',
    MAX_PRICE: 'out-maxPrice',
    MIN_PRICE: 'out-minPrice',
    STOPS: 'out-stops',
    TIMES: 'out-times',
  };
  if (query[filterName.STOPS]) selectedFilters.push(`Aktarma:Direkt Uçuşlar`);
  if (query[filterName.CLASSES])
    selectedFilters.push(`Uçuş Sınıfı:${query[filterName.CLASSES]}`);
  if (query[filterName.DEPARTURE_AIRPORTS])
    selectedFilters.push(`Havalimanı:${query[filterName.DEPARTURE_AIRPORTS]}`);
  if (query[filterName.AIRLINES])
    selectedFilters.push(`Havayolu:${query[filterName.AIRLINES]}`);
  if (query[filterName.TIMES])
    selectedFilters.push(`Uçuş Kalkış Saati:${query[filterName.TIMES]}`);
  if (query[filterName.MIN_PRICE])
    selectedFilters.push(`Minumum Fiyat:${query[filterName.MIN_PRICE]}`);
  if (query[filterName.MAX_PRICE])
    selectedFilters.push(`Maximum Fiyat:${query[filterName.MAX_PRICE]}`);
  const items: any[] = [];
  flights &&
    flights?.map((flight, index) => {
      const city: string[] = [];
      city.push(flight?.flights[0]?.segments[0]?.depCity);
      flight?.flights[0]?.segments?.map((segment) => {
        city.push(segment?.arrCity);
      });
      items.push({
        item_id: `flight`,
        item_name:
          flight?.flights[0]?.legNumber === 1
            ? `${query?.arr} - ${query?.dep}`
            : `${query?.dep} - ${query?.arr}`,
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount: 0,
        index: index,
        item_brand: `${flight?.flights[0]?.providerName}`,
        item_category: 'Uçak',
        item_category2: flight?.domestic ? 'Yurtiçi Uçuş' : 'Yurtdışı Uçuş',
        item_category3:
          query?.IsOneWay === 'true' ? 'Tek Yön' : 'Gidiş - Dönüş',
        item_category4: '',
        item_category5: '',
        cd_item_list_location: data?.flight_item_list_location || 'Uçak Bileti',
        item_list_id:
          data?.flight_item_list_id !== '' &&
          data?.flight_item_list_id !== undefined
            ? data?.flight_item_list_id
            : `${flight?.flights[0]?.segments[0]?.depCity}/${flight?.flights[0]?.segments[0]?.arrCity} Uçak Bileti`,
        item_list_name: `${
          data?.flight_item_list_location || 'Uçak Bileti'
        } - ${
          data?.flight_item_list_id !== '' &&
          data?.flight_item_list_id !== undefined
            ? data?.flight_item_list_id
            : `${city.join('/')} Uçak Bileti`
        }`,
        item_variant: '',
        cd_item_checkin_date: query?.ddate || '',
        cd_item_checkout_date: query?.rdate || '',
        cd_item_room_type: '',
        cd_item_list_filter: selectedFilters.join(',') || '',
        cd_item_sorting_opt: sortData[0].label,
        cd_item_hotel_score: '',
        cd_item_pet_friendly: 'No',
        cd_item_near_to_city_center: 'No',
        cd_item_is_seaside: 'No',
        cd_item_has_blue_flag: 'No',
        cd_item_has_aquapark: 'No',
        cd_item_otel_concept: '',
        cd_item_city: city.join(','),
        cd_item_region: '',
        cd_item_disabled_friendly: 'No',
        cd_item_is_conservative: 'No',
        cd_item_honeymoon: 'No',
        cm_item_discount_rate: 0,
        cd_item_days_till_vacation: query?.ddate
          ? diffDate(new Date().toString(), query?.ddate)
          : 0,
        cm_item_total_people_count: +(query?.ADT || 0) + +(query?.CHD || 0),
        cd_item_child_free: 'No',
        cd_item_has_fly: 'No',
        cm_item_total_reservation_day:
          query?.ddate && query?.rdate
            ? diffDate(query?.ddate, query?.rdate)
            : 0,
        cm_item_adult_number: +(query?.ADT || 0),
        cm_item_child_number: +(query?.CHD || 0),
        cd_item_in_stock: 'Yes',
        cd_item_first_price: flight?.price || 0,
        price: flight?.price || 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
      dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'TRY',
          item_list_location: items[0]?.cd_item_list_location,
          items: items,
        },
      });
      setCookie(
        'DataLayer',
        {
          ...data,
          flight_item_list_location: items[0]?.cd_item_list_location,
          flight_item_list_id: items[0]?.item_list_id,
          flight_url: window.location.href,
          //flight_select: true,
        },
        {
          expires: new Date(Date.now() + 60 * 60 * 1000),
        }
      );
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
      setCookie(
        'DataLayer',
        {
          ...data,
          flight_item_list_location: items[0]?.cd_item_list_location,
          flight_item_list_id: items[0]?.item_list_id,
          flight_url: window.location.href,
          flight_select: false,
        },
        {
          expires: new Date(Date.now() + 60 * 60 * 1000),
        }
      );
    }
  }
};
export const flightDataParser = (flights, query) => {
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');
  const selectedFilters: string[] = [];
  const filterName = {
    AIRLINES: 'out-airlines',
    CLASSES: 'out-classes',
    DEPARTURE_AIRPORTS: 'out-depAirports',
    MAX_PRICE: 'out-maxPrice',
    MIN_PRICE: 'out-minPrice',
    STOPS: 'out-stops',
    TIMES: 'out-times',
  };

  if (query[filterName.STOPS]) selectedFilters.push(`Aktarma:Direkt Uçuşlar`);
  if (query[filterName.CLASSES])
    selectedFilters.push(`Uçuş Sınıfı:${query[filterName.CLASSES]}`);
  if (query[filterName.DEPARTURE_AIRPORTS])
    selectedFilters.push(`Havalimanı:${query[filterName.DEPARTURE_AIRPORTS]}`);
  if (query[filterName.AIRLINES])
    selectedFilters.push(`Havayolu:${query[filterName.AIRLINES]}`);
  if (query[filterName.TIMES])
    selectedFilters.push(`Uçuş Kalkış Saati:${query[filterName.TIMES]}`);
  if (query[filterName.MIN_PRICE])
    selectedFilters.push(`Minumum Fiyat:${query[filterName.MIN_PRICE]}`);
  if (query[filterName.MAX_PRICE])
    selectedFilters.push(`Maximum Fiyat:${query[filterName.MAX_PRICE]}`);

  const items: any[] = [];
  flights &&
    flights?.map((flight, index) => {
      const city: string[] = [];
      city.push(flight?.segments[0]?.depCity);
      flight?.segments?.map((segment) => {
        city.push(segment?.arrCity);
      });

      items.push({
        item_id: `flight`,
        item_name:
          flight?.legNumber === 1
            ? `${query?.arr} - ${query?.dep}`
            : `${query?.dep} - ${query?.arr}`,
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount: 0,
        index: index,
        item_brand: `${flight?.providerName}`,
        item_category: 'Uçak',
        item_category2: query?.IsDomestic ? 'Yurtiçi Uçuş' : 'Yurtdışı Uçuş',
        item_category3:
          query?.IsOneWay === 'true' ? 'Tek Yön' : 'Gidiş - Dönüş',
        item_category4: '',
        item_category5: '',
        cd_item_list_location: data?.flight_item_list_location || 'Uçak Bileti',
        item_list_id:
          data?.flight_item_list_id !== '' &&
          data?.flight_item_list_id !== undefined
            ? data?.flight_item_list_id
            : `${flight?.segments[0]?.depCity}/${flight?.segments[0]?.arrCity} Uçak Bileti`,
        item_list_name: `${
          data?.flight_item_list_location || 'Uçak Bileti'
        } - ${
          data?.flight_item_list_id !== '' &&
          data?.flight_item_list_id !== undefined
            ? data?.flight_item_list_id
            : `${city.join('/')} Uçak Bileti`
        }`,
        item_variant: '',
        cd_item_checkin_date: query?.ddate || '',
        cd_item_checkout_date: query?.rdate || '',
        cd_item_room_type: '',
        cd_item_list_filter: selectedFilters.join(',') || '',
        cd_item_sorting_opt: '',
        cd_item_hotel_score: '',
        cd_item_pet_friendly: 'No',
        cd_item_near_to_city_center: 'No',
        cd_item_is_seaside: 'No',
        cd_item_has_blue_flag: 'No',
        cd_item_has_aquapark: 'No',
        cd_item_otel_concept: '',
        cd_item_city: city.join(','),
        cd_item_region: '',
        cd_item_disabled_friendly: 'No',
        cd_item_is_conservative: 'No',
        cd_item_honeymoon: 'No',
        cm_item_discount_rate: 0,
        quantity: 1,
      });
    });
  return items;
};
export const tourListAndClick = (tours, sort, filters, query, isClick) => {
  const isChatGpt = query?.kaynak ? true : false;
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');

  if (!isClick && window.location.href === data?.tour_url) return;

  const selectedFilters: string[] = [];
  filters &&
    filters?.map((item) => {
      item?.items?.map((filter) => {
        if (filter?.selected)
          selectedFilters.push(`${item?.type}: ${filter?.value}`);
      });
    });
  const items: any[] = [];
  const adultCount = 1;
  const childCount = 0;
  tours &&
    tours?.map((hotel, index) => {
      const isDomestic = hotel?.tourType === 'Abroad' ? false : true;
      const cities = hotel?.cities?.map((item) => item?.value).join(',') || '';
      items.push({
        item_id: hotel?.id || 0,
        item_name: hotel?.name || '',
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount:
          (hotel?.pricing?.rate || 0) === 0
            ? 0
            : +(hotel?.pricing?.discounted || 0) * +(hotel?.pricing?.rate || 0),
        index: index,
        item_brand: 'Setur',
        item_category: 'Tur',
        item_category2: isDomestic ? 'Yurtiçi Turlar' : 'Yurtdışı Turlar',
        item_category3: isChatGpt
          ? `${cities} Turları`
          : data?.tour_item_list_id || `${cities} Turları`,
        item_category4: hotel?.categoryName || '',
        item_category5: hotel?.countries?.map((c) => c.value).join(', ') ?? '',
        cd_item_list_location: isChatGpt
          ? 'Akıllı Asistan'
          : data?.tour_item_list_location || 'Listing Page',
        item_list_id: isChatGpt
          ? `${cities} Turları`
          : data?.tour_item_list_id || `${cities} Turları`,
        item_list_name: `${
          isChatGpt
            ? 'Akıllı Asistan'
            : data?.tour_item_list_location || 'Listing Page'
        } - ${
          isChatGpt
            ? `${cities} Turları`
            : data?.tour_item_list_id || `${cities} Turları`
        }`,
        item_variant: hotel?.tags
          ? hotel.tags
              .filter((tag: any) => tag.typeName === 'Segment')
              .map((tag: any) => tag.name)
              .join(', ')
          : '',
        cd_item_checkin_date: '',
        cd_item_checkout_date: '',
        cd_item_room_type: (hotel?.tags && hotel?.tags[0]?.name) || '',
        cd_item_list_filter: selectedFilters.join(','),
        cd_item_sorting_opt: sort?.label,
        cd_item_hotel_score: '',
        cd_item_pet_friendly: featuresCheck('Evcil hayvan', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_near_to_city_center: 'No',
        cd_item_is_seaside: featuresCheck('Denize Sıfır', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_blue_flag: featuresCheck('Mavi Bayrak', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_aquapark: featuresCheck('Aquapark', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_otel_concept: isDomestic
          ? 'Vizesiz'
          : featuresCheck('Vizesiz', hotel?.features)
          ? 'Vizesiz'
          : 'Vizeli',
        cd_item_city: cities,
        cd_item_region: hotel?.region || '',
        cd_item_disabled_friendly: featuresCheck('Engelli', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_is_conservative: featuresCheck('Muhafazakar', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_honeymoon: featuresCheck('Balayı', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_discount_rate: parseFloat(hotel?.pricing?.rate || 0) / 100,
        cd_item_days_till_vacation: 0,
        cm_item_total_people_count: +adultCount + +childCount,
        cd_item_child_free: featuresCheck('Çocuk Ücretsiz', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_fly: featuresCheck('Transfer', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_total_reservation_day: hotel?.dayStay || 0,
        cm_item_adult_number: adultCount,
        cm_item_child_number: childCount,
        cd_item_in_stock: hotel?.status === 'Available' ? 'Yes' : 'No',
        cd_item_first_price: hotel?.pricing?.selling || 0,
        price:
          (hotel?.pricing?.rate || 0) === 0
            ? hotel?.pricing?.selling || 0
            : hotel?.pricing?.discounted || 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    }
    setCookie(
      'DataLayer',
      {
        ...data,
        tour_item_list_location: items[0]?.cd_item_list_location,
        tour_item_list_id: items[0]?.item_list_id,
        tour_url: window.location.href,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  }
};

export const shipListAndClick = (ships, sort, filters, query, isClick) => {
  const isChatGpt = query?.kaynak ? true : false;
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');

  if (!isClick && window.location.href === data?.tour_url) return;

  const selectedFilters: string[] = [];
  filters &&
    filters?.map((item) => {
      item?.items?.map((filter) => {
        if (filter?.selected)
          selectedFilters.push(`${item?.type}: ${filter?.value}`);
      });
    });
  const items: any[] = [];
  const adultCount = 1;
  const childCount = 0;
  ships &&
    ships?.map((hotel, index) => {
      const isDomestic = hotel?.tourType === 'Abroad' ? false : true;
      const cities = hotel?.cities?.map((item) => item?.value).join(',') || '';
      items.push({
        item_id: hotel?.id || 0,
        item_name: hotel?.name || '',
        affiliation: 'Setur Web',
        coupon: '',
        currency: 'TRY',
        discount:
          (hotel?.pricing?.rate || 0) === 0
            ? 0
            : +(hotel?.pricing?.discounted || 0) * +(hotel?.pricing?.rate || 0),
        index: index,
        item_brand: 'Setur',
        item_category: 'Gemi',
        item_category2: 'Gemi',
        item_category3: isChatGpt
          ? `${cities} Gemi Turları`
          : data?.ship_item_list_id || `${cities} Gemi Turları`,
        item_category4: hotel?.categoryName || '',
        item_category5: hotel?.countries?.map((c) => c.value).join(', ') ?? '',
        cd_item_list_location: isChatGpt
          ? 'Akıllı Asistan'
          : data?.ship_item_list_location || 'Listing Page',
        item_list_id: isChatGpt
          ? `${cities} Gemi Turları`
          : data?.ship_item_list_id || `${cities} Gemi Turları`,
        item_list_name: `${
          isChatGpt
            ? 'Akıllı Asistan'
            : data?.ship_item_list_location || 'Listing Page'
        } - ${
          isChatGpt
            ? `${cities} Gemi Turları`
            : data?.ship_item_list_id || `${cities} Gemi Turları`
        }`,
        item_variant: hotel?.tags
          ? hotel.tags
              .filter((tag: any) => tag.typeName === 'Segment')
              .map((tag: any) => tag.name)
              .join(', ')
          : '',
        cd_item_checkin_date: '',
        cd_item_checkout_date: '',
        cd_item_room_type: (hotel?.tags && hotel?.tags[0]?.name) || '',
        cd_item_list_filter: selectedFilters.join(','),
        cd_item_sorting_opt: sort?.label,
        cd_item_hotel_score: '',
        cd_item_pet_friendly: featuresCheck('Evcil hayvan', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_near_to_city_center: 'No',
        cd_item_is_seaside: featuresCheck('Denize Sıfır', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_blue_flag: featuresCheck('Mavi Bayrak', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_aquapark: featuresCheck('Aquapark', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_otel_concept: isDomestic
          ? 'Vizesiz'
          : featuresCheck('Vizesiz', hotel?.features)
          ? 'Vizesiz'
          : 'Vizeli',
        cd_item_city: hotel?.cities?.map((item) => item?.value).join(',') || '',
        cd_item_region: hotel?.region || '',
        cd_item_disabled_friendly: featuresCheck('Engelli', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_is_conservative: featuresCheck('Muhafazakar', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_honeymoon: featuresCheck('Balayı', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_discount_rate: parseFloat(hotel?.pricing?.rate || 0) / 100,
        cd_item_days_till_vacation: 0,
        cm_item_total_people_count: +adultCount + +childCount,
        cd_item_child_free: featuresCheck('Çocuk Ücretsiz', hotel?.features)
          ? 'Yes'
          : 'No',
        cd_item_has_fly: featuresCheck('Transfer', hotel?.features)
          ? 'Yes'
          : 'No',
        cm_item_total_reservation_day: hotel?.dayStay || 0,
        cm_item_adult_number: adultCount,
        cm_item_child_number: childCount,
        cd_item_in_stock: hotel?.status === 'Available' ? 'Yes' : 'No',
        cd_item_first_price: hotel?.pricing?.selling || 0,
        price:
          (hotel?.pricing?.rate || 0) === 0
            ? hotel?.pricing?.selling || 0
            : hotel?.pricing?.discounted || 0,
        quantity: 1,
      });
    });
  if (items.length > 0) {
    if (isClick) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    } else {
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_location: items[0]?.cd_item_list_location,
          item_list_id: items[0]?.item_list_id,
          item_list_name: items[0]?.item_list_name,
          items: items,
        },
      });
    }
    setCookie(
      'DataLayer',
      {
        ...data,
        ship_item_list_location: items[0]?.cd_item_list_location,
        ship_item_list_id: items[0]?.item_list_id,
        ship_url: window.location.href,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  }
};
